module.exports = __webpack_public_path__ + "media/post-listing-block-2-overlay.8cfc37c8.webp";